import React, { Component } from "react";
import { MdErrorOutline } from "react-icons/md";

interface ErrorBoundaryProps {
  iconSize: number;
  children: React.ReactNode;
  style: object;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export default class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: any, errorInfo: any) {
    console.log(error, errorInfo);
    this.setState({
      hasError: true
    });
  }

  render() {
    const { children, iconSize, ...props } = this.props;

    if (this.state.hasError) {
      return <MdErrorOutline size={iconSize} {...props} />;
    }

    return children;
  }
}
